
import {
  Button,
  Div,
  Text,
  Modal,
  Icon,
  Anchor,
  // @ts-ignore
} from 'atomize';

export const TransactionSubmittedModal = (onClose: Function, transaction: string) => {
  const checkPurchaseString = 'Check your purchase on '
  return (
    <Modal isOpen={true} onClose={() => onClose(false)} align="start" rounded="md" bg="lightest">
      <Icon
        name="Cross"
        pos="absolute"
        top="1rem"
        right="1rem"
        size="16px"
        onClick={() => onClose(false)}
        cursor="pointer"
      />
      <Div d="flex" justify="center">
        <Text textSize="subheader" align="center">
          { checkPurchaseString }
          <Anchor
            href={`https://etherscan.io/tx/${transaction}`}
            target="_blank"
            m={{ b: "1rem" }}
          >
             Etherscan. 
          </Anchor>
          <br />
          This popup will go away after 3 confirmations and show the latest mint. You can
          find yours with the "See Your Vote" button as well.
        </Text>
      </Div>
      <Div d="flex" m={{t: "1rem"}} justify="center">
          <Button
            onClick={() => onClose(false)}
            bg="medium"
            textColor="white"
          >
          Close
        </Button>
      </Div>
    </Modal>
  )
}